import { useGetCurrentLanguage } from 'src/store/game'
import { useClientSideTranslation } from 'src/services/i18n'

type Props = Readonly<{
  country?: string
  name?: string
}>

export function PlayerDetails({name}: Props) {
  const currentLanguage = useGetCurrentLanguage()
  const { t } = useClientSideTranslation(currentLanguage)

  return (
    <>
      {name ?? t('Anonymous')}
    </>
  )
}
